(function () {
  'use strict';

  function setMode(card, mode) {
    var buy = card.querySelector('[data-buy]');
    if (!buy) return;
    card.dataset.mode = mode;
    card.querySelectorAll('[data-mode-btn]').forEach(function (button) {
      var active = button.dataset.modeBtn === mode;
      button.classList.toggle('is-active', active);
      button.setAttribute('aria-pressed', active ? 'true' : 'false');
    });
    card.querySelectorAll('[data-panel]').forEach(function (panel) {
      panel.hidden = panel.dataset.panel !== mode;
    });
    var label = buy.querySelector('[data-button-label]');
    if (label) label.textContent = mode === 'sub' ? buy.dataset.subLabel : buy.dataset.onceLabel;
    buy.setAttribute('href', mode === 'sub' ? buy.dataset.subUrl : buy.dataset.onceUrl);
  }

  function initializeRoot(root) {
    if (!root || root.dataset.rvxV2Ready === 'true') return;
    root.dataset.rvxV2Ready = 'true';
    root.querySelectorAll('[data-card]').forEach(function (card) {
      card.querySelectorAll('[data-mode-btn]').forEach(function (button) {
        button.addEventListener('click', function () { setMode(card, button.dataset.modeBtn); });
      });
      setMode(card, 'sub');
    });
  }

  function initializeAll(scope) {
    var context = scope || document;
    if (context.matches && context.matches('[data-rvx-buy-ladder-v2]')) initializeRoot(context);
    context.querySelectorAll('[data-rvx-buy-ladder-v2]').forEach(initializeRoot);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { initializeAll(document); });
  else initializeAll(document);
  document.addEventListener('shopify:section:load', function (event) { initializeAll(event.target); });
})();
